import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './CreateAssetButton.css';

interface CreateAssetButtonProps {
  parentId?: number | null;
  onClick?: () => void;
}

export function CreateAssetButton({ parentId, onClick }: CreateAssetButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
const searchParams = new URLSearchParams(location.search);
const parentsParam = searchParams.get('parents');

  const handleClick = () => {
    if (onClick) {
        onClick();
    } else {
        let url = '/create-asset';
        if (parentId) {
            url += `?parent=${parentId}`;
        } else if (parentsParam) {
            const parentIds = parentsParam.split(',');
            const immediateParent = parentIds[parentIds.length - 1];
            url += `?parent=${immediateParent}`;
        }
        navigate(url);
    }
};

  return (
    <div className="create-asset-button-container">
      <button className="create-asset-button" onClick={handleClick}>
        <i className="icon-plus"></i>
      </button>
    </div>
  );
}